import React from 'react';
import {connect} from 'react-redux';

import {updateBOCsInLayout} from "../../../actions/boCoreActions";
import {EVENTS, LAYOUT_OBJECT_TYPES} from "../../../config/boCore";
import {AgGridReact} from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css"

class LayoutBusinessObjectsGrid extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            columnDefs: [],
            rowData: [],
            gridOptions: {}
        }
    }

   UNSAFE_componentWillMount() {
        let {hiddenAndModifiedBOCsForLayout} = this.props;
        this.buildGrid(hiddenAndModifiedBOCsForLayout);

        $(document.body)
            .unbind(EVENTS.boView.objectsLayout.hidden)
            .on(EVENTS.boView.objectsLayout.hidden, (event) => {
                this.buildGrid(event.args.hiddenAndModifiedBOCsForLayout);
                event.preventDefault();
            });
    };

    UNSAFE_componentWillReceiveProps(nextProps, nextContext)  {
        this.buildGrid(nextProps.hiddenAndModifiedBOCsForLayout);
    };

    buildGrid = (hiddenAndModifiedBOCsForLayout) => {
        const columnDefs = [
            {
                headerName: "Type", field: "type", width: 50,
                checkboxSelection: true, rowGroup: true, hide: true,

            },
            {
                headerName: "System Required",
                field: "systemRequired",
                width: 50,
                rowGroup: true,
                hide: true,
                valueGetter: function (params) {
                    if (params.data) {
                        return params.data.systemRequired.toString() === "true" ? "System Required" : "NOT System Required";
                    }
                    return;
                }
            },
            {
                headerName: "NOT Visible",
                field: 'uniqueId',
                width: 140,
                checkboxSelection: true,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                sort: "asc",
                sortable: true,
                filter: "agTextColumnFilter",
                valueGetter: infoFormatter,
                tooltipValueGetter: function(params) {return params.value;}
            },

        ];
        const rowData = JSON.parse(JSON.stringify(hiddenAndModifiedBOCsForLayout))
            .sort((a, b) => a.systemRequired.toString().localeCompare(b.systemRequired.toString()))
            .sort((a, b) => a.type.localeCompare(b.type));

        const gridOptions = {
            defaultColDef: {
                resizable: true,
                filter: true,
                sortable: true
            },
            columnDefs: columnDefs,
            rowData: rowData,
            animateRows: true,
            debug: false,
            groupUseEntireRow: true,
            groupSelectsChildren: true,
            groupSelectsFiltered: true,
            suppressRowClickSelection: true,
            rowSelection: "multiple",
            floatingFilter: true,
            groupRowRendererParams: {
                checkbox: true
            },
            groupDefaultExpanded: 1,
            deltaRowDataMode: true //preserves selection and filter when data is changed by the user
        };

        // Needed for deltaRowDataMode:true
        gridOptions.getRowNodeId = function(data) {
            return data.uniqueId;
        };

        function infoFormatter(params) {
            if (params.data) {
                switch (params.data.type) {
                    case LAYOUT_OBJECT_TYPES.REL:
                        return params.data.from + " " + params.data.forward + " " + params.data.to;
                    case  LAYOUT_OBJECT_TYPES.BO:
                        return params.data.name;
                    default:
                        return;
                }
            }
            return;
        }

        this.setState({gridOptions, rowData, columnDefs});
    };

    onGridReady = (params) => {
        this.api = params.api;
        this.api.sizeColumnsToFit();
        this.api.forEachNode(function (node) {
            if (node.data && node.data.visible) {
                node.setSelected(true);
            }
        });
    };

    onSelectionChanged = (params) => {
        this.api = params.api;
        const selectedRows = this.api.getSelectedNodes();
        let selectedData = selectedRows.map(row => {
            return row.data
        });
        if (selectedRows.length > 0) {
            $("#layout_update_btn").prop("disabled", false);
        } else {
            $("#layout_update_btn").prop("disabled", true);
        }

        this.props.updateSelected(selectedData);

    };

    onFilterChanged = (params) => {
        this.api = params.api;
        this.api.deselectAllFiltered();
        let filteredNodes = [];
        this.api.forEachNodeAfterFilter((node) => {
            filteredNodes.push(node);
        });

    };


    render() {
        return (
            <div id="grid_container" style={{
                borderBottom: "2px solid black",
                height: "calc(100% - 39px)",
                margin: 0,
                padding: 0,
                width: "100%"
            }}>
                <div className="ag-theme-balham-dark ag-grids"
                     style={{backgroundColor: "#353535", width: "100%", height: "100%"}}
                     id="LayoutBusinessObjectsGrid">
                    <AgGridReact
                        onGridReady={this.onGridReady.bind(this)}
                        onFirstDataRendered={this.onGridReady.bind(this)}
                        columnDefs={this.state.columnDefs}
                        rowData={this.state.rowData}
                        gridOptions={this.state.gridOptions}
                        onSelectionChanged={this.onSelectionChanged.bind(this)}
                        onFilterChanged={this.onFilterChanged.bind(this)}
                    >
                    </AgGridReact>
                </div>
            </div>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        hiddenAndModifiedBOCsForLayout: state.boCore.hiddenAndModifiedBOCsForLayout,
        updateSelected: ownProps.updateSelected
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBOCsInLayout: (bocs) => {
            dispatch(updateBOCsInLayout(bocs));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutBusinessObjectsGrid)


// WEBPACK FOOTER //
// ./app/components/bo-core/grids/LayoutBusinessObjectsGrid.js